import type { ReactNode } from "react";
import "./data-table.css";

type Props = {
  caption: string;
  /** La didascalia resta per gli screen reader ma non si vede (il titolo della pagina la dice già). */
  captionHidden?: boolean;
  /** `<thead>` e `<tbody>`: la prima colonna di ogni riga è una `<th scope="row">`. */
  children: ReactNode;
};

// Tabella semantica «a griglia», come un foglio di calcolo: bordi verticali, righe da 40 px, prima
// colonna ferma quando la tabella scorre di lato. Su schermo stretto scorre il contenitore, non la pagina.
export function DataTable({ caption, captionHidden = false, children }: Props) {
  return (
    <div className="g-table-wrap">
      <table className="g-table">
        <caption className={captionHidden ? "g-visually-hidden" : undefined}>{caption}</caption>
        {children}
      </table>
    </div>
  );
}
